// src/components/Layout.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Login from './Login';
import './Layout.css';

function Layout({ children }) {
    const { currentUser, signOutUser, authError } = useAuth();

    return (
        <div>
            <nav className="layout-nav">
                {/* Main navigation links - hide if authError is present */}
                {!authError && (
                    <ul className="main-nav-links">
                        <li>
                            <Link to="/">Browse Interviews</Link>
                        </li>
                        <li>
                            <Link to="/questions">Browse Questions</Link>
                        </li>
                    </ul>
                )}

                {/* Auth section (user email/sign out or login button) - always render */}
                <div className="auth-section">
                    {currentUser ? (
                        <div className="user-info">
                            <p>Signed in as: {currentUser.email}</p>
                            <button onClick={signOutUser}>Sign Out</button>
                        </div>
                    ) : (
                        // Render Login only if there's no auth error, otherwise the error message is central
                        !authError && <Login />
                    )}
                </div>
            </nav>

            <main className="layout-main">
                {authError ? ( // If there's an authError, render only the error message
                    <p className="layout-auth-error-message">{authError}</p>
                ) : (
                    // Otherwise, render the children (the actual page content)
                    children
                )}
            </main>

            {/* Footer - hide if authError is present, consistent with hiding main content */}
            {!authError && (
                <footer className="layout-footer">
                    {/* Add footer content here */}
                </footer>
            )}
        </div>
    );
}

export default Layout;